import { Component, Injector, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

interface ErrorOfValidation {
  groupName: string;
  fieldName: string;
  errorName: string[];
}

@Component({
  selector: 'app-form-field-error-dialog',
  templateUrl: './form-field-error-dialog.component.html',
})
export class FormFieldErrorDialogComponent implements OnInit {
  validateList!: {
    controls?: any;
    formArray?: any;
    groupName?: string[];
    formArrayList?: any[];
  };
  errorOfValidation: ErrorOfValidation[][] = [];
  isShowErrorDialog = true;

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.validateList = this.config.data?.validateList;
    this.errorOfValidation = this.createErrorValidationList(this.validateList);
  }

  createErrorValidationList({
    controls,
    formArray,
    formArrayList = [],
    groupName = [],
  }: {
    controls?: any;
    formArray?: any;
    groupName?: string[];
    formArrayList?: any[];
  }): ErrorOfValidation[][] {
    let errorOfValidationArr: ErrorOfValidation[][] = [];
    // 處理多個中有多個的 formArray[]
    if (formArrayList && formArrayList.length > 0) {
      formArrayList.forEach((formArrayItem, index) => {
        let newGroupName = '';
        if (groupName.length > 0) {
          if (groupName[index]) {
            newGroupName = groupName[index];
          } else {
            newGroupName = groupName[0];
          }
        } else {
          newGroupName = '';
        }
        errorOfValidationArr = this.createErrorOfValidationItemFromFormArray(
          formArrayItem,
          newGroupName
        );
      });
    }
    // 處理多個 formArray
    if (formArray && formArray.controls && formArray.controls.length > 0) {
      const newGroupName = groupName && groupName[0] ? groupName[0] : '';
      errorOfValidationArr = this.createErrorOfValidationItemFromFormArray(
        formArray,
        newGroupName
      );
    }
    // 處理單個 fromGroup
    if (
      !formArray &&
      typeof controls === 'object' &&
      Object.keys(controls).length > 0
    ) {
      errorOfValidationArr = [
        this.createErrorOfValidationItem(controls, groupName[0]),
      ];
    }
    return errorOfValidationArr;
  }

  createErrorOfValidationItemFromFormArray(
    formArray: any,
    groupName: string
  ): ErrorOfValidation[][] {
    const errorOfValidation: ErrorOfValidation[][] = [];
    formArray.controls.forEach(
      (formGroup: { invalid: boolean; controls: any }, index: number) => {
        if (formGroup.invalid === true) {
          const controls = formGroup.controls;
          const no = index + 1;
          const newGroupName = groupName
            ? groupName + ' ' + (index + 1)
            : 'none';
          const errorOfValidationItem = this.createErrorOfValidationItem(
            controls,
            newGroupName
          );
          errorOfValidation.push(errorOfValidationItem);
        }
      }
    );
    return errorOfValidation;
  }

  createErrorOfValidationItem(
    controls: any,
    groupName = 'none'
  ): ErrorOfValidation[] {
    let errorOfValidationItem: ErrorOfValidation[] = [];
    let errorOfValidation;
    for (const key in controls) {
      if (Object.prototype.hasOwnProperty.call(controls, key)) {
        const field = controls[key];
        if (field.controls && field.controls.length > 0) {
          errorOfValidation = this.createErrorValidationList({
            formArray: field,
            groupName: [key],
          });
          errorOfValidation = this.flatten(errorOfValidation);
          errorOfValidationItem = [
            ...errorOfValidationItem,
            ...errorOfValidation,
          ];
        }
        if (field.errors) {
          errorOfValidationItem.push({
            groupName,
            fieldName: key,
            errorName: Object.keys(field.errors),
          });
        }
      }
    }
    return errorOfValidationItem;
  }

  flatten(input: any[]): any[] {
    const stack = [...input];
    const res = [];
    while (stack.length) {
      // pop value from stack
      const next = stack.pop();
      if (Array.isArray(next)) {
        // push back array items, won't modify the original input
        stack.push(...next);
      } else {
        res.push(next);
      }
    }
    return res.reverse();
  }

  closeErrorDialog(): void {
    this.ref.close();
  }
}
